import { customSelect } from "./custom_select";

export class Sequins {
  constructor(count, container) {
    this.count = count;
    this.container = container;
    this.copyContainer = document.querySelector("#sequins-container-copy");
    this.data = [];
  }

  template = (id) => {
    return `    <div class="w-40">
                    <span class="input-container__label">Material</span>
                    <input type="text" class="editor-form__input required editor-form__custom-select custom-material" data-type="yarn" name="sequins-no-material-${id}" id="sequins-no-material-${id}">
                    <div class="custom-select-list hidden"></div>
                </div>
                <div class="w-30">
                    <span class="input-container__label">Type</span>
                    <input type="text" class="editor-form__input editor-form__custom-select custom-type" data-type="yarn" data-id="sequins" name="sequins-no-${id}" id="sequins-no-${id}">
                    <div class="custom-select-list hidden"></div>
                </div>
                <div class="w-20">
                    <span class="input-container__label">No</span>
                    <input type="text" class="editor-form__input custom-number" data-id="sequins" name="sequins-num-no-${id}" id="sequins-num-no-${id}">
                </div>
                <div class="w-30">
                    <span class="input-container__label">Color</span>
                    <div class="color-input-container">
                        <input type="color" class="editor-form__input editor-form__input-color"
                            name="sequins-color-${id}" id="sequins-color-${id}">
                    </div>
                </div>
                <div class="w-10" >
                    <i class="fas fa-trash form-editor__icon" data-remove="sequins"></i>
                </div>
            `;
  };

addValuesToFields = () => {
  if (this.data.length === 0) return;

  // Helper: create input if missing, now targets correct row by type
  const ensureInput = (id, rowSelector, extraClass = '', type = 'text') => {
    let input = document.getElementById(id);
    if (!input) {
      const row = document.querySelector(rowSelector);
      if (!row) return null;
      const wrapper = document.createElement('div');
      wrapper.className = 'border-right border-bottom' + (extraClass ? ' ' + extraClass : '');
      wrapper.style.flex = "1";
      input = document.createElement('input');
      input.type = type;
      input.className = 'copy-form__input' + (extraClass.includes('color-input-container') ? ' copy-form__input-color' : '');
      input.id = id;
      wrapper.appendChild(input);
      row.appendChild(wrapper);
    }
    return input;
  };

  for (let i = 0; i < this.data.length; i++) {
    const name = this.data.length > i ? this.data[i].name : "";
    const material = this.data.length > i ? this.data[i].material : "";
    const yid = this.data.length > i ? this.data[i].yid : "";
    const num = this.data.length > i ? this.data[i].num : "";
    const color = this.data.length > i ? this.data[i].bg_color : "";

    // ORIGINAL fields (if you have them in flat layout)
    if(document.querySelector("#sequins-no-" + i))
      document.querySelector("#sequins-no-" + i).value = name;
    if(document.querySelector("#sequins-no-material-" + i)) {
      document.querySelector("#sequins-no-material-" + i).value = material;
      document.querySelector("#sequins-no-material-" + i).setAttribute("data-id", yid);
    }
    if(document.querySelector("#sequins-num-no-" + i))
      document.querySelector("#sequins-num-no-" + i).value = num;
    if(document.querySelector("#sequins-color-" + i)) {
      document.querySelector("#sequins-color-" + i).value = color;
      document.querySelector("#sequins-color-" + i).parentElement.style.backgroundColor = color;
    }

    // COPY fields, assign to correct row wrappers!
    ensureInput("copy-sequins-no-material-" + i, "#sequins-container-copy .sequins-row-material");
    ensureInput("copy-sequins-no-" + i,         "#sequins-container-copy .sequins-row-name");
    ensureInput("copy-sequins-num-no-" + i,     "#sequins-container-copy .sequins-row-number");
    ensureInput("copy-sequins-color-" + i,      "#sequins-container-copy .sequins-row-color", 'h-1 color-input-container', 'color');

    document.querySelector("#copy-sequins-no-" + i).value = name;
    document.querySelector("#copy-sequins-no-material-" + i).value = material;
    document.querySelector("#copy-sequins-no-material-" + i).setAttribute("data-id", yid);
    document.querySelector("#copy-sequins-num-no-" + i).value = num;
    document.querySelector("#copy-sequins-color-" + i).value = color;
    document.querySelector("#copy-sequins-color-" + i).parentElement.style.backgroundColor = color;
  }
};



  removeField = (e) => {
    this.count--;
    const iconContainer = e.target.parentElement.parentElement;
    iconContainer.remove();
    this.renderFieldNamesAndIds();
    this.updatePositions();
    this.removeCopyFieldColumn(); 
  };

  addField = () => {
  // 1. Find the next available main id
  let maxId = -1;
  this.container.querySelectorAll("input[id^='sequins-no-material-']").forEach(input => {
    const idNum = parseInt(input.id.replace("sequins-no-material-", ""), 10);
    if (!isNaN(idNum) && idNum > maxId) maxId = idNum;
  });
  const newId = maxId + 1;

  // 2. Create the new main field at newId
  const div = document.createElement("div");
  Object.assign(div, {
    className: "w-100 editor-form__subrow editor-form__subrow--modify relative",
    innerHTML: this.template(newId),
  });
  this.container.appendChild(div);
  customSelect.addScrollEventToObject(div);
  this.addFocusEventsToField(div);

  // 3. Add new copy field column **ONLY IF you now have more than 10 fields**
  const copyColumnsCount = document.querySelectorAll('#sequins-container-copy .sequins-row-material > div').length;
  if (copyColumnsCount <= newId) {
    // Only add new column if needed (e.g. after 10)
    this.addCopyFieldColumn(newId);
  }

  this.count = this.container.querySelectorAll('.editor-form__subrow').length;
  this.updatePositions();
  
  if (window.Yarn) window.Yarn.reorderSequinsCopyColumnsToYarnNumbers();

};


  renderFields = () => {
    for (let id = 0; id < this.count; id++) {
      const div = document.createElement("div");
      Object.assign(div, {
        className:
          "w-100 editor-form__subrow editor-form__subrow--modify relative",
        innerHTML: this.template(id),
      });
      this.container.appendChild(div);
    }
  };

  updatePositions = () => {
  this.removeValuesFromCopyFields();
  const containerElements = this.container.querySelectorAll(".editor-form__subrow");

  // 1. Get yarn numbers and build number => column map
  let yarnNumbers = [];
  document.querySelectorAll("input[id^='yarn-num-no-']").forEach(input => {
    let v = (input.value || "").trim();
    if (v && /^\d+\.\d+$/.test(v) && !yarnNumbers.includes(v)) yarnNumbers.push(v);
  });
  yarnNumbers.sort((a, b) => parseFloat(a) - parseFloat(b));
  const numberToColumn = {};
  yarnNumbers.forEach((num, idx) => numberToColumn[num] = idx);

  // 2. Collect sequins fields and place them by yarn number column if available
  let extraColumn = yarnNumbers.length; // for sequins with numbers not in yarn
  for (let row = 0; row < containerElements.length; row++) {
    const inputs = containerElements[row].querySelectorAll("input");
    let numVal = inputs[2].value.trim();

    // Use yarn mapping if exists, else fill left-to-right after yarns
    let colIdx = numberToColumn.hasOwnProperty(numVal) ? numberToColumn[numVal] : extraColumn++;

    // Fill copy fields at colIdx
    let el = document.querySelector(`#copy-sequins-no-material-${colIdx}`);
    if (el) el.value = inputs[0].value;
    el = document.querySelector(`#copy-sequins-no-${colIdx}`);
    if (el) el.value = inputs[1].value;
    el = document.querySelector(`#copy-sequins-num-no-${colIdx}`);
    if (el) el.value = numVal;
    el = document.querySelector(`#copy-sequins-color-${colIdx}`);
    if (el) {
      el.value = inputs[3].value;
      el.parentElement.style.backgroundColor = inputs[3].value;
    }
  }
};



  getSequinsColumnPositionForCopyForm = (targetElement) => {
    const elements = document.querySelectorAll(
      ".editor-content__form .yarn input[type='text']"
    );
    let found = false;
    let requiredElement;
    for (const element of elements) {
      if (element.value === targetElement.value) {
        found = true;
        requiredElement = element;
        break;
      }
    }
    if (!found) return targetElement.id;
    const array = requiredElement.id.split("-");
    const column = array[array.length - 1];
    return column;
  };

  removeValuesFromCopyFields = () => {
    // prettier-ignore
    const inputFields = this.copyContainer.querySelectorAll("input[type='text']");
    for (const field of inputFields) field.value = "";
    const colorFields = this.copyContainer.querySelectorAll(
      ".color-input-container"
    );
    for (const field of colorFields) field.style.backgroundColor = "#000";
  };

  renderFieldNamesAndIds = () => {
    const inputFields = this.container.querySelectorAll("input");
    // we have three input in every subcontainer
    let id = 0;
    for (let i = 0; i < inputFields.length; i++) {
      const nameParts = inputFields[i].name.split("-");
      const newName = `${nameParts.slice(0, -1).join("-")}-${id}`;
      inputFields[i].name = newName;
      inputFields[i].id = newName;
      if (i !== 0 && (i + 1) % 3 === 0) id++;
    }
    const icons = this.container.querySelectorAll("i");
    for (let i = 1; i <= icons.length; i++) {
      icons[i - 1].setAttribute("data-id", i);
    }
  };

  addFocusEventsToField = (container) => {
    const element = container.querySelector(".editor-form__custom-select");
    element.addEventListener("focus", (e) => {
      customSelect.focusSelect(e);
    });
  };

  setData = (data) => {
    if (!data) return;
    this.data = data;
    this.count = data.length;
  };
  static copyDataToForm = (field, id) => {
    const copysequins = document.querySelector("#copy-" + field.id);
    copysequins.value = id;
  };


  addCopyFieldColumn = (idx) => {
  // Add material
  let materialRow = document.querySelector("#sequins-container-copy .sequins-row-material");
  let matDiv = document.createElement("div");
  matDiv.className = "border-right border-bottom";
  matDiv.style.flex = "1";
  matDiv.innerHTML = `<input type="text" class="copy-form__input" id="copy-sequins-no-material-${idx}">`;
  materialRow.appendChild(matDiv);

  // Add name
  let nameRow = document.querySelector("#sequins-container-copy .sequins-row-name");
  let nameDiv = document.createElement("div");
  nameDiv.className = "border-right border-bottom";
  nameDiv.style.flex = "1";
  nameDiv.innerHTML = `<input type="text" class="copy-form__input" id="copy-sequins-no-${idx}">`;
  nameRow.appendChild(nameDiv);

  // Add number
  let numRow = document.querySelector("#sequins-container-copy .sequins-row-number");
  let numDiv = document.createElement("div");
  numDiv.className = "border-right border-bottom";
  numDiv.style.flex = "1";
  numDiv.innerHTML = `<input type="text" class="copy-form__input" id="copy-sequins-num-no-${idx}">`;
  numRow.appendChild(numDiv);

  // Add color
  let colorRow = document.querySelector("#sequins-container-copy .sequins-row-color");
  let colorDiv = document.createElement("div");
  colorDiv.className = "border-right border-bottom h-1 color-input-container";
  colorDiv.style.flex = "1";
  colorDiv.innerHTML = `<input type="color" class="copy-form__input copy-form__input-color" id="copy-sequins-color-${idx}">`;
  colorRow.appendChild(colorDiv);
};

removeCopyFieldColumn = () => {
  // Remove last child from each row
  ["material", "name", "number", "color"].forEach(rowType => {
    let row = document.querySelector(`#sequins-container-copy .sequins-row-${rowType}`);
    if (row && row.children.length) row.removeChild(row.lastElementChild);
  });
};

}
